import { Trans, useTranslation } from 'react-i18next';
import { ExLink, LinkSize, TargetVariant } from '@boomi/exosphere';

function AgentGardenLink({ agentGardenUrl }: any) {
  const [t] = useTranslation('common');
  const isConsumerExperience = window.location.href.includes('chat');
  const isAgentFoundation = window.location.href.includes('home');
  let landingSubHeading = '';
  if (isAgentFoundation) {
    landingSubHeading = t('ai_landing_page_sub_heading_consumer_experience');
  } else if (isConsumerExperience) {
    landingSubHeading = t('ai_landing_page_sub_heading_consumer_experience');
  } else {
    landingSubHeading = t('ai_landing_page_sub_heading');
  }

  return (
    <div>
      <Trans
        i18nKey={(landingSubHeading)}
        t={t}
        components={{
          'ex-link': (
            <ExLink
              href={agentGardenUrl}
              target={TargetVariant.SELF}
              aria-label="Visit AI Agent Garden"
              trailingIcon="Right arrow"
              size={LinkSize.DEFAULT}
            />
          ),
        }}
      />
    </div>
  );
}
export default AgentGardenLink;
